export default {
  en: {
    status: '%{current} of %{total} steps completed',
  },
};
